// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__8ODhZ","textArea__white":"TextArea_textArea__white__egc6m","textArea__label":"TextArea_textArea__label__Mjc0w"};